import React from 'react';
import moment from 'moment';

export default class Footer extends React.Component {
    constructor(args) {
        super(args);
        this.state = {
            version: getAppVersion(),
			year: moment().year()
        }
    }

    render() {
        return (
            <footer className="main-footer">
                <div className="pull-right hidden-xs"><b>Версия</b> {this.state.version}</div>
                <strong>© {this.state.year} <a href="http://artlogics.ru/" target="_blank">Artlogic</a></strong>
            </footer>
        );
    }
};


// WEBPACK FOOTER //
// ./App/containers/footer.jsx